// extracted by mini-css-extract-plugin
export default {"delete":"delete-mode-toggle_delete__dI2FP","toggle":"delete-mode-toggle_toggle__9v0u5","text":"delete-mode-toggle_text__YJFB1"};